
import React, { useState, useEffect } from 'react'
import * as ctf from "contentful";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LogoSlider from "./logo_slider";
import SocialIcons from "./social_icons";
import ContactForms from "./contactForm"

import { documentToHtmlString } from "@contentful/rich-text-html-renderer"
import parse from 'html-react-parser';

const Contact = () => {

  const [contactData, setContactData] = useState([]);
  const client = ctf.createClient({
    space: "fdtw7gymput4",
    accessToken: "-b6ZWs0OGwtdJjGTqdBxGGG5D5iITPNdSgVKo4stF7E",
  });

  useEffect(() => {
    fetchDataHome();
  }, []);

  const fetchDataHome = async () => {
    try {
      const resp = await client.getEntries({ content_type: "contactPage" });
      setContactData(resp.items);
    } catch (error) {
      console.log(error);
    }
  };
  console.log("all Data", contactData)

  return (
    <div>
      <div className="about-info">
        <div>
          <h1 className="text-black contact_heading py-3" style={{ fontSize: '90px', marginTop: '60px' }}>Contact Us</h1>
        </div>
        <div className="contact-top">
          <div className="row">
            {contactData && contactData?.reverse()?.map((item, index) => {
              return (
                <div className="col-lg-4" key={index} >
                  <div className="address">
                    <h3 className="text-black">{item?.fields?.areaName}</h3>
                    <div className='addres_div'>
                      {item?.fields?.areaAddress && (
                        parse(documentToHtmlString(item?.fields?.areaAddress))
                      )}
                      {/* {item?.fields?.areaAddress} */}
                    </div>
                    <p>
                      <a href={`tel:${item?.fields?.phoneNumber}`}>{item?.fields?.phoneNumber}</a>
                    </p>
                    <p>
                      <a href={`mailto:${item?.fields?.areaEmail}`}>{item?.fields?.areaEmail}</a>
                    </p>
                  </div>
                </div>
              )
            })}

            {/* <div className="col-lg-4">
              <div className="address">
                <h3 className="text-black">MIDDLE EAST</h3>
                <p>
                  Suite 1702, Level 17 <br />
                  Boulevard Plaza Tower 1 <br />
                  Sheikh Muhammad Bin Rashid Boulevard <br /> Dubai
                </p>
                <p>
                  <a href="tel:+971 52 201 0651">+971 52 201 0651</a>
                </p>
                <p>
                  <a href="mailto:hello@littlebig.global">hello@littlebig.global</a>
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="address">
                <h3 className="text-black">EUROPE</h3>
                <p>
                  Kanaalstraat 36-3 <br />
                  Amsterdam <br />
                  Netherlands <br />
                  1054XJ
                </p>
                <p>
                  <a href="tel:+31 6 27299687">+31 6 27299687</a>
                </p>
                <p>
                  <a href="mailto:hello@littlebig.global">hello@littlebig.global</a>
                </p>
              </div>
            </div> */}
          </div>
        </div>
        <div className="contact-info-form">
          <h3 className="text-black">Get in touch</h3>
          <p>
            We’d love for you to get in touch with us so we can create magic! Fill out the form below and we’ll be in touch as soon as humanly possible.
          </p>
          <ContactForms />

        </div>
        <ToastContainer />
      </div>
      <div className="logos_animations">
        <LogoSlider />
      </div>
      <SocialIcons />
    </div>
  );
};

export default Contact;
